var map = {
	"./1-risk.png": 6703,
	"./1.png": 1199,
	"./2-insure.png": 8044,
	"./2.png": 4151,
	"./3-save.png": 8718,
	"./3.png": 3110,
	"./4-kyc.png": 7952,
	"./4.png": 9051,
	"./5-yield.png": 5627,
	"./5.png": 2375,
	"./6-planning.png": 1239,
	"./6.png": 6250,
	"./7-assets.png": 5601,
	"./7.png": 7695,
	"./8-wealthmanagement.png": 2639,
	"./9-strategies.png": 5199,
	"./BNS-PassportVI.png": 7144,
	"./CIBCAeroPlanBusiness.png": 5990,
	"./CIBCAeroplanStudents.png": 8351,
	"./CIBCClassicVisa.png": 7480,
	"./CIBCVISAInfiniteSelect.png": 920,
	"./GoalSettingPurr.mp4": 203,
	"./Momentum_Visa_Infinite_ENG.avif": 5542,
	"./Passport_Visa_Infinite_CreditCard_0421_Eng.png": 8411,
	"./RiskyPawsLogo.png": 3112,
	"./RiskyPawsLogoText.png": 129,
	"./RiskyPawsLogowithtext.png": 8150,
	"./SB-MomentumNoFee.png": 3960,
	"./SB-Scene-Student.png": 4790,
	"./SB-Scene-black.png": 7498,
	"./TDlogo.png": 2029,
	"./approved.gif": 550,
	"./basketofkittens.png": 1315,
	"./bengraham2.png": 5583,
	"./black-debit-card.jpeg": 2771,
	"./blank-card.png": 3335,
	"./blankcard.png": 6877,
	"./bmo-airmiles-we.png": 6146,
	"./bmo-airmiles.png": 8267,
	"./bmo-ascend-we.png": 3877,
	"./bmo-cbp-we.png": 2596,
	"./bmo-cbp.png": 755,
	"./bmo-ecl-vi.png": 4549,
	"./bmo-ecl-vip.png": 4651,
	"./bmo-pref.png": 2383,
	"./bmo-rewards.png": 2396,
	"./bmo.png": 6467,
	"./bns-axp-plat.png": 7010,
	"./bns-earn.png": 1495,
	"./bns-mom-vi.png": 1724,
	"./bns-mom.png": 4008,
	"./bns-scene.png": 1066,
	"./bns-sceneplus.png": 5708,
	"./bns-us.png": 9226,
	"./bns-value-stu.png": 9044,
	"./bns-value.png": 5629,
	"./cat-box.gif": 7405,
	"./cat-confetti.gif": 273,
	"./cat-kiss.gif": 7457,
	"./cat-notimpressed.gif": 9234,
	"./cat-pissed.gif": 5893,
	"./cat-sad.gif": 531,
	"./cat-sleeping.gif": 5797,
	"./cat-yarn.gif": 915,
	"./catfalling.mp4": 9399,
	"./catinfo.png": 2773,
	"./catlifestages.png": 9141,
	"./catpawcursor.png": 3177,
	"./catpurr.mp3": 5118,
	"./catpurrloud.mp3": 2822,
	"./catwatchingball.png": 2884,
	"./cibc-aeroplan-vi.png": 3002,
	"./cibc-aeroplan-vip.png": 160,
	"./cibc-aeroplan-visa-biz.png": 1804,
	"./cibc-aeroplan.png": 7450,
	"./cibc-aventura-biz.png": 4130,
	"./cibc-aventura-bizplus.png": 8874,
	"./cibc-aventura-gold.png": 3085,
	"./cibc-aventura-stu.png": 5451,
	"./cibc-aventura-vi.png": 9584,
	"./cibc-aventura.png": 5424,
	"./cibc-avenutra-bizplus.png": 6196,
	"./cibc-bizline.png": 8731,
	"./cibc-classic-stu.png": 5716,
	"./cibc-classic.png": 3401,
	"./cibc-corp.png": 7870,
	"./cibc-costco-biz.png": 3192,
	"./cibc-costco.png": 4624,
	"./cibc-div-plat.png": 9182,
	"./cibc-div-stu.png": 1148,
	"./cibc-div-vi.png": 4704,
	"./cibc-div.png": 4819,
	"./cibc-select.png": 8794,
	"./cibc-us-aventura.png": 2364,
	"./cpo-aspire-cash.png": 8492,
	"./cpo-aspire.png": 3806,
	"./cpo-smart.png": 4278,
	"./cpx_businessplatinumavion_en_sm - Edited - Edited - Edited.png": 29,
	"./ct-triangle-we.png": 7065,
	"./ct-triangle.png": 9067,
	"./customer-placeholder.png": 2288,
	"./denied.gif": 9421,
	"./desj-bonus.png": 7046,
	"./desj-cbp-mc.png": 7753,
	"./desj-cbp-we.png": 5477,
	"./desj-ody-gold.png": 3399,
	"./desj-ody-vip.png": 5909,
	"./desj-ody-we.png": 905,
	"./femalecat.png": 8599,
	"./financial-growth-icon.png": 7525,
	"./financialcalendar.png": 2461,
	"./financialdashboard.png": 3738,
	"./financialliteracy.png": 2580,
	"./finlit.png": 8311,
	"./finliteracy.png": 1344,
	"./flashcards.png": 4701,
	"./framework.png": 3175,
	"./framework/1-risk.png": 7597,
	"./framework/2-insure.png": 532,
	"./framework/3-save.png": 2320,
	"./framework/4-kyc.png": 2058,
	"./framework/5-yield.png": 2657,
	"./framework/6-planning.png": 7413,
	"./framework/7-assets.png": 3134,
	"./framework/8-wealthmanagement.png": 4842,
	"./framework/9-strategies.png": 6715,
	"./ht-pref.png": 8285,
	"./laur-cbp.png": 6897,
	"./laur-explore.png": 9346,
	"./laur-reduced.png": 5851,
	"./laur-rewardme.png": 6013,
	"./laur.png": 74,
	"./loanofficercat.png": 7116,
	"./logo.png": 6949,
	"./mbna-legion.png": 6305,
	"./mbna-smart.png": 3515,
	"./mbna-smartcash.png": 2170,
	"./muezza.png": 4086,
	"./nbc-allure.png": 2131,
	"./nbc-echo.png": 7028,
	"./nbc-mc1.png": 3062,
	"./nbc-mycredit.png": 7877,
	"./nbc-plat.png": 9061,
	"./nbc-sync.png": 9783,
	"./nbc-world.png": 9782,
	"./networthincome.png": 9785,
	"./newbiekitten.png": 814,
	"./personalasset.png": 8432,
	"./plt_platinum_en_sm - Edited - Edited - Edited.png": 5270,
	"./plusicon.png": 4477,
	"./quantcat.png": 5879,
	"./questions.png": 5793,
	"./quizzes.png": 3292,
	"./rbc-avion-biz.png": 2417,
	"./rbc-avion-vi.png": 3302,
	"./rbc-avion.png": 962,
	"./rbc-ba-vi.png": 4160,
	"./rbc-biz-avion-vi.png": 6626,
	"./rbc-biz-cb.png": 4007,
	"./rbc-biz-visa.png": 3251,
	"./rbc-cbp.png": 4723,
	"./rbc-creditline.png": 6706,
	"./rbc-ion.png": 4814,
	"./rbc-lowrate.png": 5961,
	"./rbc-moi.png": 2559,
	"./rbc-rateadv.png": 4580,
	"./rbc-us-gold.png": 2890,
	"./rbc-visa-plat.png": 6771,
	"./rbc-wj-mc.png": 286,
	"./rbc-wj-we.png": 2138,
	"./riskypaws.png": 2838,
	"./scenarios.png": 3124,
	"./stingycat-airplane.png": 7586,
	"./stingycat.png": 711,
	"./stingychat.png": 8513,
	"./tang-cbp.png": 9659,
	"./tang.png": 7273,
	"./tangerine-debit.png": 9814,
	"./td-aeroplan-biz.png": 4450,
	"./td-aeroplan-business.jpg": 2205,
	"./td-aeroplan-vi.png": 908,
	"./td-aeroplan-vip.png": 1169,
	"./td-aeroplan-vp.png": 4553,
	"./td-biz-cp.png": 6537,
	"./td-biz-select.png": 3423,
	"./td-biz-trv.png": 6841,
	"./td-cash-back.png": 327,
	"./td-cashback-vi.png": 1902,
	"./td-cashback.png": 8157,
	"./td-emd.jpg": 3801,
	"./td-emd.png": 3488,
	"./td-emd.png.jpg": 2814,
	"./td-fct-vi.png": 2660,
	"./td-plt-trv.png": 6080,
	"./td-rewards.png": 4983,
	"./td-us.png": 6571,
	"./tdcard.png": 9483,
	"./wmt-rewards-world.png": 7954,
	"./wmt-rewards.png": 5698,
	"./yellowcatwatchingball.png": 1353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;